import React, {
  useState,
  useEffect
} from 'react'
import { domToReact } from 'html-react-parser'
import {
  Form
} from 'antd'
import SortableList,
{
  SortableItem
} from 'react-easy-sort'
import { arrayMoveImmutable } from 'array-move'

const SortImageList = (props) => {

  const { value, onChange } = props
  const [items, setItems] = useState([])

  const onSortEnd = (oldIndex, newIndex) => {

    const newlist = arrayMoveImmutable(items, oldIndex, newIndex)
    const newlistIndexes = newlist.map(item => item.index)
    const newFieldValue = newlistIndexes // JSON.stringify(newlistIndexes) 

    onChange(newFieldValue)
    setItems(newlist)
  }

  useEffect(() => {

    const orderedIndexes = value ? 
    value // JSON.parse(value) 
    :
    props.children.map((o, i) => i)

    setItems(
      orderedIndexes
      .map((index) => {

        return {
          index,
          element: props.children[index]
        }
      })
    )

  }, [value])


  return <SortableList
    onSortEnd={onSortEnd}
    className="list"
    draggedItemClassName="dragged"
    allowDrag={ !props.formcontext?.eventData?.instance.closed }
  >
    {
      items.map(
        (item, index) => {

          return <SortableItem key={index}>
            <div className="item">
              {
                domToReact(
                  item.element.children,
                  {
                    replace: props.replace
                  }
                )
              }
            </div>
          </SortableItem>
        }
      )
    }
  </SortableList>
}

export const OrderImages = props => {

  const form = Form.useFormInstance()
  const [ formContext, setFormContext ] = useState()

  const required = props.parent.attribs['data-required'] == 'true'

  useEffect(() => {

    if(form) {
      
      setFormContext(form)
    }

  }, [form])

  return <div 
    className={`
      wp-block-playmotivcloud-surveyanswer orderimages
      ${ formContext?.eventData?.instance.closed ? 'disabled' : '' }
    `}
  >
    <Form.Item
      name={props.parent.attribs['data-blockid']}
      rules={[{ required: required, message: "Este campo es obligatorio" }]}
    >
      <SortImageList 
        { ...props } 
        formcontext={ formContext }
      />
    </Form.Item>
  </div>
}
